import React from "react"
import PropTypes from "prop-types"
import ConnectRequestItem from './ConnectRequestItem'
import ConnectSectionHeader from './ConnectSectionHeader'

class ConnectRequests extends React.Component {
  renderRequests() {
    return(this.props.requestedConnects.map((req, i) => {
      return (
        <ConnectRequestItem
          req={req}
          key={i}
        />
      )
    }))
  }

  render() {
    const count = this.props.requestedConnects.length

    return(
      <section className="connectsSection connectsSection--highlight">
        <ConnectSectionHeader
          icon="users-alt"
          title="Connect Requests"
          subtitle="Someone wants to practice with you — accepting is free!"
          badge={count}
        />
        {this.renderRequests()}
      </section>
    )
  }
}

ConnectRequests.propTypes = {
  requestedConnects: PropTypes.array.isRequired,
}

export default ConnectRequests
